import React from 'react'
import { Box, Checkbox, Typography, styled } from '@mui/material'

export const CheckRowWrapper = styled(Box)`
  display: flex;
  width: 100%;
  padding: 12px;
  align-items: flex-start;
  align-self: flex-start;
  column-gap: 4px;
  background: #222a04;
`

interface CheckProps {
  value: boolean
  toggle: () => void
  lockTime: number
  action: 'stake' | 'unstake' | 'claim'
}

const Check = ({ value, toggle, lockTime, action }: CheckProps) => {
  const lockDay = lockTime / 86400

  const actionTextMap = {
    stake: 'the stake is increased',
    unstake: 'it is unstaked',
    claim: 'it is claimed',
  }

  return (
    <CheckRowWrapper>
      <Checkbox
        sx={{
          '&:hover': { bgcolor: 'transparent' },
          p: 0,
        }}
        disableRipple
        checked={value}
        onChange={toggle}
        size="small"
      />
      <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#30C65A' }}>
        The staked income will be locked for {lockDay} {lockDay > 1 ? 'days' : 'day'} by default. Each time{' '}
        {actionTextMap[action]}, the locking time will be reset.
      </Typography>
    </CheckRowWrapper>
  )
}

export default Check
